export class FitnessTrends {
  static member({ meta, summary, modules }) {
    return {
      year: meta.year,
      firstName: meta.first_name,
      userId: meta.user_id,
      summary: {
        minutes: summary.minutes,
        activities: summary.activities || summary.activites, // temporarily accommodates a typo in the service
        friendCount: summary.friend_count,
        studioCount: summary.studio_count,
        cityCount: summary.city_count,
      },
      tiles: modules.map((data, index) => ({
        description: data.description,
        id: index,
        header: data.header,
        number: data.number,
        subheader: data.subheader,
        type: data.type,
      })),
    };
  }
}
